import React from "react";
import { styled } from "styled-components";
const SpinnerStyle = styled.span `
  animation: spinner-border 1s linear infinite;
  border-radius: 50%;
  border-color: currentColor currentColor currentColor transparent;
  border-style: solid;
  border-width: 0.2em;
  display: inline-block;
  height: 1rem;
  margin-right: 1ch;
  position: relative;
  vertical-align: middle;
  width: 1rem;

  @keyframes spinner-border {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(180deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
export const Spinner = () => React.createElement(SpinnerStyle, null);
Spinner.displayName = "Spinner";
export default Spinner;
//# sourceMappingURL=Spinner.js.map